import { Content } from './types'

const subheading: Content = {
    type: 'subheading',
    name: 'Tussenkop',
}

export default subheading
